import { getCurrentLocale, getRequest } from '../../utils'
import { ReportsType } from './enums/reportsType'
import { BaseInput } from './types/inputTypes'
import { ReportOptions } from './types/reportOptions'
import { getQueryStringFromReportParams } from './utils/getQueryStringFromReportParams'
import { BalanceSheetInputBalance } from './views/NL/balanceSheetReport/types/inputTypes'
import { ProfitAndLossInputBalance } from './views/NL/profitAndLossReport/types/inputTypes'
import { TrialBalanceInputBalance } from './views/NL/trialBalanceReport/types/inputTypes'

export const fetchTrialBalanceReport = async (
  organizationId: string,
  options: ReportOptions,
): Promise<BaseInput<TrialBalanceInputBalance>> => {
  const locale = getCurrentLocale()
  const queryParams = getQueryStringFromReportParams(ReportsType.TrialBalance, options)
  const { data } = await getRequest(`/v2/organizations/${organizationId}/reports/trialBalance?${queryParams}`, {
    'accept-language': locale,
  })

  return data
}

export const fetchBalanceSheetReport = async (
  organizationId: string,
  options: ReportOptions,
): Promise<BaseInput<BalanceSheetInputBalance>> => {
  const locale = getCurrentLocale()
  const queryParams = getQueryStringFromReportParams(ReportsType.BalanceSheet, options)

  const { data } = await getRequest(`/v2/organizations/${organizationId}/reports/balanceSheet?${queryParams}`, {
    'accept-language': locale,
  })

  return data
}

export const fetchProfitAndLossReport = async (
  organizationId: string,
  options: ReportOptions,
): Promise<BaseInput<ProfitAndLossInputBalance>> => {
  const locale = getCurrentLocale()
  const queryParams = getQueryStringFromReportParams(ReportsType.ProfitAndLoss, options)

  const { data } = await getRequest(`/v2/organizations/${organizationId}/reports/profitAndLoss?${queryParams}`, {
    'accept-language': locale,
  })

  return data
}
